import {
  PROJET_NAME_BODAC,
  PROJET_NAME_AALV,
  PROJET_NAME_AA,
  PROJET_NAME_PORTAIL_FOURNISSEUR,
  PROJET_NAME_PORTAIL_CLIENT,
} from '@/configuration/imageConnexion';

export const PARAMETRES_INTERNE_ADMIN = {
  title: 'Paramètrage interne',
  breadcrumb: {
    parametrageInterne: 'Paramètrage interne',
  },
  tabs: {
    fonction: 'Fonctionnalités',
    module: 'Modules',
    specifique: 'Spécifique',
    produit: 'Produits',
    gestionInterface: 'Gestion interface',
  },
  messages: {
    success: {
      edit: 'Paramètres internes modifiés avec succès.',
    },
  },
  gestionInterface: {
    message: {
      title: 'Messages acceuil',
      ajouter: 'Nouveau message',
      tabs: {
        message: 'Message',
        dateDebutAffichage: 'Date de début',
        dateFinAffichage: 'Date de fin',
        visibleUniquement: 'Visible uniquement',
      },
      form: {
        add: 'Créer un message',
        edit: 'Modifier un message',
        message: 'Message',
        dateDebutAffichage: 'Date de début',
        dateFinAffichage: 'Date de fin',
        visibleUniquement: 'Message visible uniquement sur ce tenant',
      },
      createSuccess: 'Message a été cré avec succès',
      updateSuccess: 'Message a été modifié avec succès',
      deleteSuccess: 'Message a été supprimé avec succès',
      error: {
        message: 'Message',
        dateDebutAffichage: 'Date de début',
      },
      supprimerMessage: {
        delete: 'Etes-vous sûr de vouloir supprimer ce message ?',
        irreversible: 'La suppression du message est irréversible',
      },
    },
    imageConnexion: {
      title: 'Image de connexion',
      modifier: 'Modifier l\'image',
      supprimer: 'Supprimer l\'image',
      updateSuccess: 'Image de connexion a été modifié avec succès',
      popUp: {
        supprimer: 'Etes-vous sûr de vouloir supprimer l\'image ?',
        irreversible: 'La suppression de l\'image est irréversible',
      },
      projets: {
        [PROJET_NAME_BODAC]: 'BODAC',
        [PROJET_NAME_AALV]: 'AALV',
        [PROJET_NAME_AA]: 'AA',
        [PROJET_NAME_PORTAIL_FOURNISSEUR]: 'PORTAIL FOURNISSEUR',
        [PROJET_NAME_PORTAIL_CLIENT]: 'PORTAIL CLIENT',
      },
    },
  },
};

export const PARAMETRES_INTERNE_CLIENT = {
  title: 'Configuration du site',
  breadcrumb: {
    config: 'Configuration site',
  },
  messages: {
    warning: {
      edit: 'Toute modification des données de cette page peut entraîner des modifications sur tout le site',
      prevention: 'Etes-vous sûr de vouloir modifier la configuration du site ?',
    },
    success: {
      edit: 'Configuration du site modifiée avec succès.',
    },
  },
};

export const IMPOR_DATA = {
  title: 'Importer des données',
  breadcrumb: {
    config: 'Import de donnée',
  },
  info: {
    title: 'A lire avant action',
    message: 'Etape 1 : prendre le template puis le remplir (ce qui n\'est pas dans les '
      + 'colonnes n\'est pas géré)<br>Etape 2 : importer le fichier'
      + ' (ne doit pas faire d\'import en base / pour le paramétrage il y a un throw si '
      + 'ce n\'est pas connu)<br>Etape 3 : regarder la console avec le résultat'
      + ' de l\'import<br>Etape 4 : Envoyer les données (pop up de prevention'
      + '/ ouvrir la console avant import pour regarder les requêtes)',
  },
  patrimoine: {
    title: 'Importer des emplacements / dispositifs / matériels /faces',
    description: 'Le script n\'ajoute pas le paramétrage mais affiche la propriete manquante dans\n'
      + 'la console et stop la mise en forme<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Le script va chercher l\'agenceId automatiquement<br>'
      + 'Tester le script en pp<br>'
      + 'Pour les emplacements clients, l\'import des clients doit être fait au préalable.<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  bailleur: {
    title: 'Importer des bailleurs',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  client: {
    title: 'Importer des clients',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Pour la colonne "marques", chaque ligne doit contenir une liste de marque séparée uniquement par des virgules et entourée de guillemets<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>'
      + 'Si il y a un erreur sur une ligne, elle n\'est pas traitée. Ceci peut avoir des incidences sur les erreurs vis à vis codes groupes et enseignes<br>',
  },
  bail: {
    title: 'Importer des baux',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script prend un template avec 3 onglets baux, lien baux/bailleurs, lien baux/patrimoines<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Il faut que les colonnes de codeBailleur, codeMateriel, codeBail soient au format text<br>'
      + 'Il faut que la colonne de quotePart pour l\'onglet Lien bail bailleur soit au format text<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  commande: {
    title: 'Importer des commandes',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script prend un template avec 3 onglets commandes, intervenants, lignes commandes<br>'
      + 'Le script ajoute les produits si non existant<br>'
      + 'Les colonnes pour les tiers se recherche par nom commercial sauf indications contraire<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Regarder si tous les champs sont corrects<br>',
  },
  facture: {
    title: 'Importer des factures',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script prend un template avec 2 onglets commandes, lignes commandes<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  contact: {
    title: 'Importer des contacts',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Pour la colonne "type de contact", chaque ligne peut contenir une liste de type de contact séparée uniquement par des virgules et entourée de guillemets<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  contactTiers: {
    title: 'Importer des contacts / tiers',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Pour la colonne "type de contact", chaque ligne peut contenir une liste de type de contact séparée uniquement par des virgules et entourée de guillemets<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  patrimoineNomenclature: {
    title: 'Importer des nomenclatures pour le patrimoine',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  campagne: {
    title: 'Importer des campagnes',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Pour la colonne "tags", chaque ligne peut contenir une liste de tag séparée uniquement par des virgules et entourée de guillemets<br>'
      + 'Pour la colonne "Code client", elle correspond à la référence externe du client. Cette information est obligatoire.<br>'
      + 'Pour la colonne "Type de contact", chaque ligne peut contenir une liste de type de contact séparée uniquement par des virgules et entourée de guillemets<br>'
      + 'Il faut que les colonnes de date soient au format text<br>'
      + 'Regarder si tous les champs sont correct<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  demandeimpression: {
    title: 'Importer des demandes d\'impression',
    description: 'Le script ajoute le paramétrage<br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Pour la colonne "Code client", elle correspond à la référence externe du client. Cette information est obligatoire.<br>'
      + 'Pour la colonne "Code structure", elle correspond au code du dispositif.<br>'
      + 'Pour la colonne "Libelle", elle correspond au nom de la campagne.<br>'
      + 'Regarder si tous les champs sont correct<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  actions: {
    template: 'Obtenir le template',
    importer: 'Importer le fichier',
    envoyer: 'Envoyer les données',
    testerDonnees: 'Tester l\'envoie des données',
  },
  sucessTestImport: 'Le test d\'import est un succès.',
  success: 'Import réalisé',
  prevention: 'Attention : il va y avoir un import de donnée via l\'api, avant de continuer veuillez vérifier votre import dans la console.',
  preventionUser: 'Attention! Etes-vous sur de vouloir effectuer l\'import des données?',
  preventionFile: 'Attention : il y a des erreurs dans votre fichier. Télécharger le fichier d\'erreur pour corriger les données.',
  messages: {
    error: {
      texte: 'Problème(s) sur la ligne n° {num} : {errors}',
      general: 'Un problème est survenu: {errors}',
    },
    warning: {
      edit: 'Un import de donnée va ajouter des informations dans votre base de donnée, après un import on ne peux pas revenir en arrière',
      prevention: 'Etes-vous sûr de vouloir modifier la configuration du site ?',
    },
  },
  infoDataPret: {
    title: 'Données prêtes',
    message: 'Vos données ont été formatés avec succès et sont prêtes pour l\'import.',
  },
  dataNotExist: '{data} n\'est pas dans affixe.',
  numLigne: 'Ligne {num} :',
  bonStock: {
    title: 'Reprise solde stock',
    description: 'Le script n\'ajoute pas le paramétrage <br>'
      + 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester le script en pp<br>'
      + 'Pour la colonne "Ref. Externe Client", elle correspond à la référence externe du client. Cette information est obligatoire<br>'
      + 'Il faut que les colonnes de solde bache soient au format numérique<br>'
      + 'L\'ajout des produits stockables par défaut doit être fait au préalable.<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
  logoDispositif: {
    title: 'Reprise logo dispositif',
    description: 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Si l\'url du logo ne fonctionne pas, l\'import ignora ce cas'
      + 'Tester le script en pp<br>'
      + 'Regarder si tous les champs sont corrects<br>'
      + 'Il faut supprimer le $$ du fichier translate<br>',
  },
};

export const EXPOR_DATA = {
  title: 'Exporter des données',
  breadcrumb: {
    config: 'Export de donnée',
  },
  info: {
    title: 'A lire avant action',
    message: 'Exporte toutes les données de la société relatives au titre de la carte',
  },
  actions: {
    exporter: 'Exporter le fichier',
  },
  patrimoine: {
    title: 'Exporter des emplacements / dispositifs / matériels / faces',
    description: 'L\'export se base sur la vue V_STAT_PATRIMOINE',
  },
  bailleur: {
    title: 'Exporter des bailleurs',
    description: 'L\'export se base sur la vue V_STAT_TIERS',
  },
  client: {
    title: 'Exporter des clients',
    description: 'L\'export se base sur la vue V_STAT_TIERS',
  },
  bail: {
    title: 'Exporter des baux',
    description: 'L\'export se base sur la vue V_STAT_EXPORT_BAIL',
  },
  success: 'Export réalisé',
};

export const PARAMETRES_INTERNE = {
  titre_nom: 'Paramètres',
  titre_description: 'Descriptions',
  titre_valeur: 'Valeurs',
  titre_client: 'Client',
  ibizaBaseUrl: 'Url Ibiza',
  ibizaBaseUrl_description: 'url pour l\'export IBIZA',
  ibizaPartnerId: 'Ibiza partner ID',
  ibizaPartnerId_description: 'ID pour l\'export IBIZA',
  portailClientBaseUrl: 'URL portail client',
  portailClientBaseUrl_description: 'Url de redirection pour le portail client',
  filtrerProduitParSociete: 'Filtre produits par société',
  filtrerProduitParSociete_description: 'Permet de filtrer les produits par société',
  filtrerProduitParAgence: 'Filtre produits par agence',
  filtrerProduitParAgence_description: 'Permet de filtrer les produits par agence',
  googleMapApiKey: 'Clef API google map',
  googleMapApiKey_description: 'Clef API pour afficher le composant de google map',
  mentionMandataire: 'Mention mandataire',
  mentionMandataire_description: 'Affichage de la mention mandataire pour l\'édition de devis, commande et facture',
  blocageFiltreCommercial: 'Blocage du filtre des commerciaux',
  blocageFiltreCommercial_description: 'Si un commercial arrive sur un écran de recherche, le filtre "Commercial" (initialisé avec son identifiant) sera bloqué',
  checkCompteComptable: 'Validation compte comptable sur les factures',
  nombreTraitesParPage: 'Nombre de traites par page sur les factures',
  nombreTraitesParPage_description: 'Détermine le nombre de traites maximum a afficher par page dans les factures',
  affichageCommercialDcf: 'Coordonées du commercial',
  affichageCommercialDcf_description: 'Affichage des coordonées du commercial dans les devis, commandes et factures',
  periodeTotalCalculTlpeAuto: 'Calcul TLPE auto sur période',
  periodeTotalCalculTlpeAuto_description: 'Le calcul de la TLPE sur fait sur toute la période du devis ou de la commande (au lieu d\'être fait que sur 1 an)',
  nbAnneeRenouvellementContrat: 'Nombre d\'année renouvellement bail',
  nbAnneeRenouvellementContrat_description: 'Nombre d\'année par défaut lors du renouvellement d\'un bail. Si pas rempli, on prend la durée initiale du contrat',
  masquerCgvSurFacture: 'Masquer CGV sur les factures',
  masquerCgvSurFacture_description: 'Détermine si les conditions générales de vente sont masquées sur les factures',
  produitAdressePersonaliseeDefaut: 'Valeur par defaut de l\'indicateur de d\'adresse personnalisée sur les produits faces et numériques',
  produitAdressePersonaliseeDefaut_description: 'Si vrai alors les adresses commerciales ne seront jamais écrasées par le patrimoine (attention ce parametre n\'impacte que les nouveaux patrimoines créés)',
  autoriserAuthentificationAffixe1: 'Indique si l\'authentification affixe1 est autorisée',
  autoriserAuthentificationAffixe1_description: 'Si true alors oui, si false alors non, si warn alors autorisée mais avec un warning',
  afficherLogistiqueTechnique: 'Module logistique technique',
  filtrerAutoParUtilisateur: 'Filtre automatique par utilisateur connecté (Directeur commercial, Commercial, Assistant commercial)',
  filtrerAutoParUtilisateur_description: 'Permet de filtrer automatiquement les écrans listes par utilisateur connecté (Directeur commercial, Commercial, Assistant commercial)',
  activationYield: 'Activation Yield',
  controleYield: 'Contrôle Yield',
  controleYield_description: 'Permet de Contrôler  le montant de vente tempo par rapport à son objectif',
  titreCommandeOrdrePublicite: 'Afficher "Ordre de publicité" sur les commandes',
  titreCommandeOrdrePublicite_description: 'Si activé, le titre des commandes sera "Ordre de publicité" au lieu de "Commande"',
  listeAlpha2CodePaysLimiteAutocompleteGoogle: 'Liste des codes Alpha 2 des pays qui limite l\'autocomplete google. Ex: "fr|re" pour la France et la Réunion - (5 pays maximum)',
  modulePresse: 'Module version presse',
  produit: {
    salon: 'Produit salon',
    salon_description: 'Ajout du produit de type Salon dans l\'application',
    sponsoring: 'Produit sponsoring/événementiel',
    sponsoring_description: 'Ajout du produit de type Sponsoring/Événementiel dans l\'application',
    autre: 'Produit autre',
    autre_description: 'Ajout du produit de type Autre dans l\'application',
    presse: 'Produit presse',
    presse_description: 'Ajout du produit de type Presse dans l\'application',
    ReseauMairie: 'Produit réseau mairie',
    ReseauMairie_description: 'Ajout du produit de type réseau mairie dans l\'application',
    ReseauNumerique: 'Produit réseau numérique',
    ReseauNumerique_description: 'Ajout du produit de type réseau numérique dans l\'application',
    faceUnitaire: 'Produit face unitaire',
    faceUnitaire_description: 'Ajout du produit de type Face unitaire dans l\'application',
    reseauLc: 'Produit réseau LC',
    reseauLc_description: 'Ajout du produit de type réseau LC dans l\'application',
    reseauTempo: 'Produit réseau temporaire',
    reseauTempo_description: 'Ajout du produit de type réseau temporaire dans l\'application',
    impressionAffiche: 'Produit impression d\'affiche',
    impressionAffiche_description: 'Ajout du produit de type impression d\'affiche dans l\'application',
  },
  afficherProjetDossierLogistiqueTechnique: 'Afficher projet/dossier dans la logistique technique',
  nombreMoisPreavisParDefaut: 'Nombre de mois préavis par défaut',
  nombreMoisPreavisParDefaut_description: 'Permet de définir un nombre de mois de préavis par défaut lors d\'une création de régie',
  editionOtWithReseau: 'Edition OT d\'affichage avec affichage du réseau et sans grattage et sans affichage effectué',
  acompteAvecTva: 'Permet de définir si les acomptes doivent avoir de la TVA ou non dans leurs écritures comptables (attention ne gère pas les factures avec plusieurs taux de TVA)',
  NbreMoisDefaultFiltreJournal: 'Journal : période sur mois précédant',
  NbreMoisDefaultFiltreJournal_description: 'Dans le journal comptable, la période par défaut est sur le mois précédant',
  logoParAgence: 'Utilisation des logos par agence dans les éditions de DCF',
  logoParAgence_description: 'Attention nécessite d\'avoir des logos d\'agence de la même taille que pour la société, doit utiliser le back pour envoyer les logos des agences',
  majAutoAdresseCommercialeAvecEnAllantVers: 'Maj automatique de l\'adresse commerciale lors de la création ou maj d\'un élément de patrimoine qui doit impacter un produit ',
  blocSignatureAgence: 'Ajout d\' un bloc de signature pour l\'agence dans la commande',
  blocSignatureAgence_description: 'Dans le cas ou une commande qui n\'est pas contresignée est considérée comme nulle',
  prelevementSepa: 'Prélèvement SEPA',
  prelevementSepa_description: 'Ne pas oublier de mettre le logo SEPA dans la société',
  affixeMobile: 'Module Audit Technique Mobile',
  retrocessionAlfa: 'Rétrocession ALFA',
  emailContactPayeurEditionFacture: 'Email contact payeur sur l\'édition d\'une facture',
  priseEnCompteMontageLogistique: 'Prise en compte montage logistique',
  priseEnCompteMontageLogistique_description: 'Permet de filtrer les faces qui ne sont pas à l\'état "à monter" ou "encours de montage" dans la logistique',
  recopierTousLesPayeursSurFacture: 'Recopier tous les payeurs dans la facture',
  recopierTousLesPayeursSurFacture_description: 'Dans le cas d\'une commande multi-payeurs, est-ce que la facture doit recopier tous les intervenants qui ne sont que payeurs?',
  afficherRegleFacturationEditionFacture: 'Règle de facturation sur l\'édition d\'une facture',
  moduleFactor: 'Module factor',
  tableUserParam: 'Paramétrage de tous les tableaux de l\'application',
  remiseComptabilisee: 'Remise comptabilisée',
  remiseComptabilisee_description: 'Prise en compte des remises lors de la génération des lignes d\'écritures',
  moduleMobileOT: 'Module OT technique Mobile',
  affixeMobileOTAffichage: 'Module OT Affichage mobile',
  ajouterBATdansMail: 'Inclure les BAT aux mails d\'envoi de Bat',
  ajouterBATdansMail_description: "Valeur par défaut lors que l'envoi de mail depuis la page des BAT",
  calculCaFace: 'Activation de calcul du chiffres d\'affaire dans l\'edition de baux et l\'export de face',
  signatureElectronique: 'Signature électronique',
  emailAutorizeFrom: 'Permets d\'envoyer des emails dont les adresses "From" et "Reply-To" sont identiques.',
  moduleEmplacementClient: 'Module emplacement client',
  HSPParutionExport: 'Export spécifique des parutions',
  HSPParutionExport_client: 'HSP',
  exportLvc_client: 'LVC',
  exportLvc: 'Export lignes factures',
  desactivationControleSignatureSurVenteDevis: 'Désactivation du contrôle de vente sur les devis pour la signature électronique',
  desactivationControleSignatureSurVenteDevis_description: 'Permets de désactiver le contrôle fait sur les lignes vendables d\'un devis pour la signature électronique.',
  modulePortailBailleur: 'Module portail bailleur',
  ligneCommandeARenouvelerSpe: 'Liste ligne commande à renouveler spécifique',
  ligneCommandeARenouvelerSpe_client: 'HUP MEDIA',
  marqueObligatoirePointDeVenteSpe: 'Marque obligatoire sur les points de vente et les enseignes',
  marqueObligatoirePointDeVenteSpe_client: 'HUP MEDIA',
  editionSpeFicheFace: 'Edition spécifique de fiche de face',
  editionSpeFicheFace_client: 'Graphic',
  rendreObligatoireAssistantEtCommercialSurCommandeFacture: 'Rends obligatoire l\'assistant et le commercial sur les commandes et factures',
  rendreObligatoireAssistantEtCommercialSurCommandeFacture_client: 'CBA',
  editionPlanningReseauxTemposRegieMedia: 'Edition planning réseaux',
  editionPlanningReseauxTemposRegieMedia_client: 'Régie média',
  modulePortailClient: 'Module portail client',
  CBAprevisionnelDepart: 'Ecran prévisionnel de départ',
  CBAprevisionnelDepart_client: 'CBA',
  DimensionExportDcfCbaSpe: 'Ajout dimensions dans l\'export de faces vendues',
  DimensionExportDcfCbaSpe_client: 'CBA',
  DimensionExportDcfCbaSpe_description: 'Ajoute la dimension dans l\'export des faces vendues (tempo) dans les commandes',
  MedialinePlanningLCRenouvellement_client: 'MEDIALINE',
  MedialinePlanningLCRenouvellement: 'Planning LC Renouvellement',
  moduleMarche: 'Module Marché',
  moduleMarche_description: 'Attention rends obligatoire l\'activation du module fournisseur de support',
  modulePlanMedia: 'Module plan média',
  moduleFournisseurSupport: 'Module fournisseur de support',
  moduleIndexationCommande: 'Module indexation commande',
  importCommandeIdelia_client: 'IDELIA',
  importCommandeIdelia: 'Import commande IDELIA',
  moduleStockTiers: 'Module stock client',
  echeancesAFacturerAA_client: 'Affichage autorisé',
  echeancesAFacturerAA: 'Liste des échéances à facturer',
  echeancesAFacturerNegativesAA_client: 'Affichage autorisé',
  echeancesAFacturerNegativesAA: 'Echéances à facturer négatives',
  campagne: 'Campagne',
  moduleRegroupementProduit: 'Module regroupement de produit',
  demandeImpression: 'Demande d\'impression',
  moduleSecteur: 'Module Secteur',
  filtreAgence: 'Filtre par societe/agence dans la logistique d\'affichage',
  filtreAgence_description: 'Active la prise en compte du filtre d\'agence et de société dans la logistique d\'affichage',
  contactsVenteSuperieur: 'Contacts vente supérieur',
  contactsVenteSuperieur_description: 'Permet de voir le contacts d\'un client Parent lors de l\'ajout sur un document de vente',
  interdireModificationBlocageCLG_client: 'CLG',
  interdireModificationBlocageCLG: 'Interdiction de modifier un blocage',
  moduleEcranNumerique: 'Module Ecran Numérique',
  champObligatoireFacture: 'Champs obligatoires sur facture',
  champObligatoireFacture_description: 'Permet de rendre obligatoire les champs suivants : "Nom commercial" - "Adresse postale (Intitulé 1-  Adresse 1 - Code Postal - Ville - Pays)" - "Siret" – "TVA intracommunautaire" -  "Mode de règlement" - "Délai de règlement" - "Compte comptable" sur les intervenants d\'une facture',
  futurisEditionSpeReseauTempo_client: 'GROUPE GIRAUDY',
  futurisEditionSpeReseauTempo: 'Edition des reseau tempo',
  moduleLogistiqueImpression: 'Module logistique impression',
  moduleAchat: 'Module achat',
  cbaDiaporama: 'CBA Diaporama',
  cbaDiaporama_client: 'CBA',
  achatAASpe: 'Permet d\'afficher et de gérer l\'onglet "Achat" dans les pages de détail, de modification de facture, et de modification d\'échéancier de paiement d\'une facture enregistrée.',
  achatAASpe_client: 'Affichage autorisé',
  exportAloesredSpe: 'Offre la possibilité d\'exporter les commandes à renouveler et les matériels de manière spécifique.',
  exportAloesredSpe_client: 'Aloesred',
  relevePubLvcSpe: 'Releve pub LVC',
  relevePubLvcSpe_client: 'LVC',
  commissionHorsMarche: 'Module de commission Hors Marché',
  factureClientHupmedia_client: 'HUP MEDIA',
  factureClientHupmedia: 'Dans l\'onglet "Factures" de l\'écran détail du client, afficher les factures du client au lieu des lignes factures',
  demandeAvoirBailleurGirodMediasSpe: 'Demande d\'avoir bailleur',
  demandeAvoirBailleurGirodMediasSpe_client: 'Girod medias',
  demandeAvoirBailleurGirodMediasSpe_description: 'Ajoute une action "Demande d\'avoir bailleur" pour une échéancensur l\'onglet échéancier d\'un détail de bail',
};
